import Loading from "./Loading.js";
const components_Loading = Loading;
export { components_Loading as default };
